
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./vfs.cjs.production.min.js')
} else {
  module.exports = require('./vfs.cjs.development.js')
}
